import { render, staticRenderFns } from "./VulnerabilityAuditGroupedByVulnerability.vue?vue&type=template&id=a2a46692&"
import script from "./VulnerabilityAuditGroupedByVulnerability.vue?vue&type=script&lang=js&"
export * from "./VulnerabilityAuditGroupedByVulnerability.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2a46692')) {
      api.createRecord('a2a46692', component.options)
    } else {
      api.reload('a2a46692', component.options)
    }
    module.hot.accept("./VulnerabilityAuditGroupedByVulnerability.vue?vue&type=template&id=a2a46692&", function () {
      api.rerender('a2a46692', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/globalAudit/VulnerabilityAuditGroupedByVulnerability.vue"
export default component.exports